import React from "react";
import PropTypes from "prop-types";
import "./PackageCard.scss";
import { useNavigate } from "react-router-dom";

const tileSizes = {
	large: "large_package_card",
	small: "small_package_card",
};

const Tile = ({
	size,
	tag,
	title,
	description,
	cost,
	pill,
	disclaimer,
	listSpecs,
	keyModels,
	logos,
	tactics,
	cta,
	link,
}) => {
	const navigate = useNavigate();
	const sizeClass = tileSizes[size] || tileSizes;

	const tileCostClass = pill ? "tile_cost" : "tile_cost tile_cost_empty_pill";
	const renderDollarSign = pill ? <span>$</span> : null;

	return (
		<div className={`package_tile_container ${sizeClass}`}>
			{size === "small" &&
				tag && ( //only for small
					<p className="tile_tag">{tag}</p>
				)}
			<div className="tile_top_container">
				<div>
					{title && <h3 className="tile_title">{title}</h3>}

					{size === "large" &&
						cta && ( //only for large
							<p className="tile_description">{description}</p>
						)}
				</div>
				<div className="tile_cost_container">
					<div>
						{renderDollarSign}
						{cost && <p className={tileCostClass}>{cost}</p>}
					</div>
					{pill && <span className="tile_pill">{pill}</span>}
				</div>
			</div>
			{!pill && <p className="tile_budget_disclaimer">{disclaimer}</p>}

			{size === "large" && <h4 className="tile_small_title">Tactics</h4>}
			{tactics && tactics.length > 0 && (
				<ul className="tile_specs">
					{tactics.map((tactic, index) => (
						<li key={index} className="tile_spec_item">
							{tactic}
						</li>
					))}
				</ul>
			)}

			{/* <h4 className="tile_small_title">Tactics</h4>

			<div className="logo_container">
				{size === "large" &&
					tactics &&
					tactics.length > 0 &&
					tactics.map((tactic, index) => (
						<div key={index} className="tactic_item">
							<img
								src={require("../../assets/solidCheck.png")}
								alt="check"
								className="tactic_check"
							/>
							<p className="logo_text">{tactic}</p>
						</div>
					))}
			</div> */}

			{size === "large" && ((logos && logos.length > 0) || (keyModels && keyModels.length > 0)) && (
				<h4 className="tile_small_title">Core Model Options</h4>
			)}
			<div className="logo_container">
				{size === "large" &&
					logos &&
					logos.length > 0 &&
					logos.map((logo, index) => (
						<p key={index} className="logo_text">
							{logo}
						</p>
					))}
			</div>

			<div className="logo_container">
				{size === "large" &&
					keyModels &&
					keyModels.length > 0 &&
					keyModels.map((model, index) => (
						<p key={index} className="logo_text">
							{model}
						</p>
					))}
			</div>

			{size === "large" && cta && (
				<>
					<button
						className="tile_cta"
						onClick={() => navigate("/enroll")}>
						{cta}
					</button>
					<p className="tile_disclaimer">
						*All costs are media. No added fees.
					</p>
				</>
			)}
		</div>
	);
};

Tile.propTypes = {
	size: PropTypes.oneOf(["large", "small"]),
	title: PropTypes.string,
	cost: PropTypes.string,
	pill: PropTypes.string,
	listSpecs: PropTypes.arrayOf(PropTypes.string),
	keyModels: PropTypes.arrayOf(PropTypes.string),
	logos: PropTypes.arrayOf(PropTypes.string),
	tactics: PropTypes.arrayOf(PropTypes.string),
	cta: PropTypes.string,
};

export default Tile;
